<ul class="card-content">
  <li class="card-name">
    <div *ngIf="card.image" class="image" [style.background-image]="cardBackgroundImage(card)">
      <img alt="card image" src="{{card.image}}"/>
    </div>

    <div class="text-area">
      <div *ngIf="showEllipsisMenu; else noEllipsisMenu" class="title">
        <h5 data-testid="entity-card-title">
          <ng-container *ngIf="card.link; else noLinkName">
            <a data-testid="linked-name" [routerLink]="card.link">{{card.name}}</a>
          </ng-container>
          <ng-template #noLinkName>
            {{card.name}}
          </ng-template>
        </h5>

        <ng-container *ngIf="card.badges">
          <span
            *ngFor="let badge of card.badges"
            class="badge"
            [class]="badge.class"
            [inlineSVG]="badge.icon"
            [matTooltip]="badge.tooltip"
            matTooltipClass="entity-card-tooltip"
            matTooltipPosition="above"
          >
            {{badge.label}}
          </span>
        </ng-container>
      </div>

      <ng-template #noEllipsisMenu>
        <div class="title">
          <h5 data-testid="entity-card-title">
            <ng-container *ngIf="card.link && card.fullCpc; else noLinkName">
              <a [routerLink]="card.link">{{card.name}}</a>
            </ng-container>
            <ng-template #noLinkName>
              <p data-testid="locked-org-name" class="locked-org-name">
                {{card.name}}
                <span
                  data-testid="locked-org-icon"
                  [matTooltip]="'Limited Organization Access'"
                  matTooltipClass="entity-card-tooltip"
                  matTooltipPosition="above"
                  inlineSVG="assets/icons/lock.svg"
                ></span>
              </p>
            </ng-template>
          </h5>

          <ng-container *ngIf="card.badges">
          <span
            *ngFor="let badge of card.badges"
            class="badge"
            [class]="badge.class"
            [inlineSVG]="badge.icon"
            [matTooltip]="badge.tooltip"
            matTooltipClass="entity-card-tooltip"
            matTooltipPosition="above"
          >
            {{badge.label}}
          </span>
          </ng-container>
        </div>
      </ng-template>

      <small *ngIf="card.meta">{{card.meta}}</small>
    </div>
  </li>

  <li class="card-primary-badge" *ngIf="card.primaryBadge">
    <span
      [class]="card.primaryBadge.class"
      [inlineSVG]="card.primaryBadge.icon"
      [matTooltip]="card.primaryBadge.tooltip"
      matTooltipClass="entity-card-tooltip"
      matTooltipPosition="above"
    >
      {{card.primaryBadge.label}}
    </span>
  </li>

  <ng-container *ngIf="!expanded">
    <li
      class="card-data"
      matTooltipPosition="below"
      [class.numeric]="data.numeric"
      [matTooltip]="data.tooltip"
      *ngFor="let data of card.data"
    >
      <small>{{data.label}}</small>
      {{data.value || '–'}}
    </li>
  </ng-container>

  <li class="card-primary-action" *ngIf="card.primaryAction">
    <button
      (click)="card.primaryAction.action(card.primaryAction.data)"
      type="button"
      [disabled]="card.primaryAction.disabled"
    >{{card.primaryAction.label}}</button>
  </li>

  <ng-container *ngIf="card.actions">
    <li class="card-action" [class.with-label]="action.label" *ngFor="let action of card.actions">
      <button [attr.data-testid]="action.dataTestId" (click)="action.action(action.value)">
        <div class="icon" [inlineSVG]="action.icon"></div>
        <ng-container *ngIf="action.label">{{action.label}}</ng-container>
      </button>
    </li>
  </ng-container>

  <li class="card-action" *ngIf="card.table">
    <button (click)="toggleExpansion()" [class.expanded]="expanded" inlineSVG="/assets/icons/chevron-down.svg"
            data-testid="expand-table-btn"></button>
  </li>

  <ng-container *ngIf="card.menu && showEllipsisMenu">
    <li data-testid="card-menu" class="card-menu">
      <div class="card-menu-trigger" inlineSVG="/assets/icons/more-vert.svg" role="button"
           [matMenuTriggerFor]="menu"></div>
      <mat-menu #menu="matMenu" data-testid="ellipsis-menu">
        <ng-container *ngFor="let item of card.menu.items">
          <button mat-menu-item (click)="item.action(item.value)"
                  [attr.data-testid]="'entity-card-action'">{{item.label}}</button>
        </ng-container>
      </mat-menu>
    </li>
  </ng-container>
</ul>

<fl-collection-table
  [class.expanded]="expanded"
  [columnSettings]="card.table.columnSettings"
  [customSort]="card.table.customSort"
  [dataSourceData]="card.table.dataSourceData"
  [matSortActive]="card.table.matSortActive"
  [matSortDirection]="card.table.matSortDirection"
  [showFooter]="card.table.showFooter"
  *ngIf="card.table"
></fl-collection-table>
